
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"12","cy":"12","r":"8","stroke":"#828282","stroke-width":"2"}}),_c('circle',{attrs:{"cx":"12","cy":"8.5","r":"1.5","fill":"#828282"}}),_c('rect',{attrs:{"x":"11","y":"11","width":"2","height":"6","rx":"1","fill":"#828282"}})])
          )
        }
      }
    